import { GroupDTO } from '../../http/dtos/groups/groupsDTO';
import httpClient from '../../http/httpClient';

export const groupsRepository = {
    GetGroupsList: () => {
        return httpClient.get('/groups').then((response: GroupDTO[]) => response);
    },
};
